import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DialogInfoComponent } from './components/dialog-info/dialog-info.component';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';
import { ExpansionPanelHeaderComponent } from './components/expansion-panel-header/expansion-panel-header.component';
import { ExpansionPanelBodyComponent } from './components/expansion-panel-body/expansion-panel-body.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ErrorFormComponent } from './components/error-form/error-form.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import { SessionExpiredDialogComponent } from './components/session-expired-dialog/session-expired-dialog.component';
import { ChangeBpComponent } from './components/navbar/change-bp/change-bp.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from './pipes/date/date.pipe';

@NgModule({
  declarations: [
    FooterComponent,
    NavbarComponent,
    DialogInfoComponent,
    ExpansionPanelComponent,
    ExpansionPanelHeaderComponent,
    ExpansionPanelBodyComponent,
    LoadingComponent,
    ErrorFormComponent,
    DialogConfirmComponent,
    SessionExpiredDialogComponent,
    ChangeBpComponent,
    DatePipe
  ],
  imports: [
    CommonModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatDialogModule,
    ReactiveFormsModule
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    DialogInfoComponent,
    ExpansionPanelComponent,
    ExpansionPanelHeaderComponent,
    ExpansionPanelBodyComponent,
    LoadingComponent,
    ErrorFormComponent,
    DialogConfirmComponent,
    ChangeBpComponent,
    DatePipe
  ]
})
export class SharedModule { }
